import React, { useState } from "react"
import { Outlet, Route, Routes } from "react-router-dom"
import Synthese from "components/transactionDataTable/Synthese"
import AccountRecharge from "components/transactionDataTable/AccountRecharge"
import NavTabs from "components/common/nav-tabs/NavTabs"
import {
  TRANSACTIONS_URL,
} from "@/constants/mainRoutes"
function Transactions() {
  const [transactionStats,setTransactionStats] = useState({
    monthlyRevenue: 2450000,
    growthRate: 15.3,
    unusedBalance: 32450000,
  })
  const [currentTab, setCurrentTab] = useState<number>(0)
  const pathname = location.pathname
  const navItems = [
    { link: "", value: "Synthèse" },
    { link: "recharge", value: "Demande de rechargement" },
  ]


  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setCurrentTab(newValue)
  }
  return (
    <div className="py-2 px-4 space-y-2">
      <div className="bg-white pt-2 px-2 mb-5 rounded-lg">
        <NavTabs navItems={navItems} baseRoute={TRANSACTIONS_URL} className="gap-7 "/>
      </div>

      <div className=" space-y-6">
        <Routes>
          <Route index element={<Synthese/> } />
          <Route path="recharge" element={ <AccountRecharge/> } />
        </Routes>
      </div>
      <Outlet />
        {/*<Tabs defaultValue="Synthese">*/}
        {/*  <TabsList className="w-full bg-white border-b rounded-none justify-start">*/}
        {/*    <TabsTrigger*/}
        {/*      value="Synthese"*/}
        {/*      className="data-[state=active]:border-b-2 data-[state=active]:border-primary rounded-none"*/}
        {/*    >*/}
        {/*      Synthèse*/}
        {/*    </TabsTrigger>*/}

        {/*    <TabsTrigger*/}
        {/*      value="Demande"*/}
        {/*      className="data-[state=active]:border-b-2 data-[state=active]:border-primary rounded-none"*/}
        {/*    >*/}
        {/*      Demande de rechargement*/}
        {/*    </TabsTrigger>*/}
        {/*  </TabsList>*/}
        {/*  <TabsContent value="Synthese">*/}
        {/*    <Synthese/>*/}
        {/*  </TabsContent>*/}
        {/*  <TabsContent value="Demande">*/}
        {/*    <AccountRecharge/>*/}
        {/*  </TabsContent>*/}

        {/*</Tabs>*/}

    </div>
  )

}


export default Transactions
